import React from "react";
import { X, Download, Loader2, Gift, Info } from "lucide-react"; // Changed CheckCircle2 to Info
import * as Dialog from "@radix-ui/react-dialog";

const UnsyncedRewardsPopup = ({
  onImport,
  onClose,
  importing = false,
  hasRewards = true,
}) => {
  return (
    <Dialog.Root
      defaultOpen
      onOpenChange={(open) => {
        if (!open && onClose) {
          onClose();
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />

        <Dialog.Content
          onOpenAutoFocus={(e) => e.preventDefault()}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
        >
          <div className="max-w-md w-full mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden ring-1 ring-black/5 p-6 md:p-8 flex flex-col items-center text-center relative">
            <Dialog.Close asChild>
              <button
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full hover:bg-gray-100 focus:outline-none"
                disabled={importing}
                aria-label="Close"
              >
                <X className="w-5 h-5" />
              </button>
            </Dialog.Close>

            {/* Icon Logic: Red Gift if rewards found, Blue Info if not */}
            <div
              className={`w-16 h-16 rounded-full flex items-center justify-center mb-5 ${
                hasRewards
                  ? "bg-red-50 text-crimsonGlory"
                  : "bg-blue-50 text-blue-600"
              }`}
            >
              {hasRewards ? (
                <Gift className="w-8 h-8" strokeWidth={1.5} />
              ) : (
                <Info className="w-8 h-8" strokeWidth={1.5} />
              )}
            </div>

            {/* Title Update */}
            <Dialog.Title className="text-xl font-bold text-gray-900 mb-2">
              {hasRewards ? "Unsynced Rewards Found" : "No Rewards Found"}
            </Dialog.Title>

            {/* Description Update */}
            <Dialog.Description className="text-gray-500 mb-8 max-w-[280px] mx-auto leading-relaxed text-sm md:text-base">
              {hasRewards
                ? "We found pending rewards not yet synced to your account. Import them now to update your balance."
                : "We checked for unsynced rewards, but didn't find any pending rewards to import."}
            </Dialog.Description>

            <div className="flex flex-col-reverse sm:flex-row gap-3 w-full">
              {hasRewards ? (
                <>
                  <Dialog.Close asChild>
                    <button
                      className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 hover:text-gray-900 transition-all focus:outline-none focus:ring-2 focus:ring-gray-200"
                      disabled={importing}
                    >
                      Maybe Later
                    </button>
                  </Dialog.Close>

                  <button
                    onClick={onImport}
                    disabled={importing}
                    className="flex-1 bg-crimsonGlory text-white px-4 py-2.5 rounded-xl hover:bg-red-700 transition-all flex items-center justify-center gap-2 font-medium shadow-lg shadow-red-900/10 focus:outline-none focus:ring-2 focus:ring-red-200 disabled:opacity-70 disabled:cursor-not-allowed"
                  >
                    {importing ? (
                      <>
                        <Loader2 className="w-4 h-4 animate-spin" />
                        <span>Syncing...</span>
                      </>
                    ) : (
                      <>
                        <Download className="w-4 h-4" />
                        <span>Import Rewards</span>
                      </>
                    )}
                  </button>
                </>
              ) : (
                <Dialog.Close asChild>
                  <button className="w-full bg-gray-900 text-white px-4 py-2.5 rounded-xl hover:bg-gray-800 transition-all font-medium focus:outline-none">
                    Ok
                  </button>
                </Dialog.Close>
              )}
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default UnsyncedRewardsPopup;
